import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 16C2 8.60425 7.73472 2.54791 15 2.03516V4.20768C8.93267 4.71542 4.16675 9.80081 4.16675 15.9993C4.16675 22.5347 9.46471 27.8327 16.0001 27.8327C22.5355 27.8327 27.8334 22.5347 27.8334 15.9993C27.8334 11.2774 25.0676 7.20337 21.072 5.30528L20.2138 7.1118C23.5384 8.6911 25.8334 12.0782 25.8334 15.9993C25.8334 21.4302 21.4309 25.8327 16.0001 25.8327C10.9071 25.8327 6.71841 21.9608 6.21704 17H10.083C10.2514 18.0038 10.669 18.9232 11.2702 19.6921L9.95712 20.7186C10.8076 21.8066 11.9464 22.6596 13.2605 23.1625C14.1126 23.4886 15.0367 23.6668 16.0002 23.6668C20.2343 23.6668 23.6668 20.2343 23.6668 16.0002C23.6668 11.766 20.2343 8.3335 16.0002 8.3335C12.105 8.3335 8.88822 11.2384 8.39814 15H6.2169C6.71767 10.0386 10.9066 6.16602 16.0001 6.16602V6H17V2.03516C24.2653 2.54791 30 8.60425 30 16C30 23.732 23.732 30 16 30C13.8625 30 11.8396 29.5217 10.0299 28.6672L9.17596 30.4757C11.2471 31.4536 13.5611 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 19.9524 1.43441 23.5724 3.80985 26.3639L5.33301 25.0677C3.25378 22.6243 2 19.4599 2 16Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }